import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, map, tap } from 'rxjs/operators';
import { KbLoadingService } from '../sapSpartacus/loading.service';
import { KBPageMetaService } from '../feature/kb-page-meta.service';

export const urlsToCheck: { [key: string]: boolean } = {
  'mysavedcart/saved-carts': true,
  'quote/myquotes/details': true,
  'myaccount/addressbook/edit-address': true,
  'mysavedcart/savedcartdetails': true,
  createshippingaddress: true,
  selectaddress: true,
  shippingaddress: true,
  review: true,
  deliveryoptions: true,
  customerinformation: true,
  'mycompnay/getmycompanyuser': true,
  'mytraining/training-registered': true,
  'mytraining/training-confirmation': true,
  'myaccount/addressbook/add-address': true,
  'addressbook/address-book': true,
  'mycompnay/edit': true,
};

@Injectable({ providedIn: 'root' })
export class HttpBreadCrumbInterceptor implements HttpInterceptor {
  constructor(protected kbPageMetaService: KBPageMetaService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter((event: HttpEvent<any>) => event instanceof HttpResponse),
      tap((event: any) => {
        if (event?.body?.breadcrumbs) {
          this.kbPageMetaService.customBreadcrumbs$.next(event?.body?.breadcrumbs);
        } else if (event?.body?.message?.breadcrumbs) {
          this.kbPageMetaService.customBreadcrumbs$.next(event.body.message.breadcrumbs);
        }
      })
    );
  }
}
